import { createPopup } from "@typeform/embed";
import { INewUser } from "@wingspanhq/users/dist/lib/interfaces";
import { useCallback } from "react";
import { useUserId } from "../../../query/hooks/helpers";
import { useQueryUserProfile } from "../../../query/users/queries";
import {
  analyticsService,
  getSegmentAnonymousIdFromLocalStorage
} from "@services/analyticsService";

const TYPEFORM_URL = "https://wingspan.typeform.com/to/xXS6mQu8";

/** Opens the "Request a new benefit" typeform, prefilled with the member's details. */
export const useRequestBenefitTypeform = () => {
  const userId = useUserId();
  const queryUserProfile = useQueryUserProfile(userId);

  return useCallback(() => {
    const user = queryUserProfile.data as INewUser | undefined;

    if (!user) {
      return;
    }

    const anonymousId = getSegmentAnonymousIdFromLocalStorage();
    const fullName = `${user.profile.firstName} ${user.profile.lastName}`;

    createPopup(
      `${TYPEFORM_URL}#name=${fullName}&email=${user.email}&userid=${userId}&anonymousid=${anonymousId}`,
      {
        onSubmit: responseId => {
          analyticsService.track("Request a new benefit form submitted", {
            responseId
          });
        }
      }
    ).open();
  }, [userId, queryUserProfile.data]);
};
